// Turns an RTK Query error into a sentence a player can act on.
export function describeApiError(error: any, context: "login" | "register" | "guest" = "login"): string {
    const status = error?.status;
    const serverMsg: string | undefined = error?.data?.error
        || (error?.data?.errors ? Object.values(error.data.errors).join(" ") : undefined);
    if (status === "FETCH_ERROR" || status === "TIMEOUT_ERROR")
        return "Can't reach the game server. Check your connection and try again.";
    if (status === 401 && context === "login") return "Wrong email or password.";
    if (status === 409) return serverMsg || "An account with this email already exists.";
    if (status === 429) return "Too many attempts. Please wait a few minutes and try again.";
    if (typeof status === "number" && status >= 500) return "The server had a problem. Please try again in a moment.";
    return serverMsg || "Something went wrong. Please try again.";
}
